import {OfferSwitcher} from "./Order/OfferSwitcher";
import {PromoCode} from "./Order/PromoCode";
import {Quantity} from "./Order/Quantity";
import {Phone} from "../modules/Phone";
import {City} from "../modules/City";
import {Address} from "./Order/Address";
import {AddressPicker} from "./Order/AddressPicker";
import {Toggle} from "../modules/Toggle";
import {CustomModal} from "../modules/CustomModal";
import BasketChanges from "./Order/BasketChanges";

export class Order {
    constructor(element) {
        this.order = $(element);

        this.setElementClasses();

        this.REDIRECT_URL = '/personal/cart/?ORDER_ID=';

        this.showAuthModal = false;

        this.form = this.order.find('.' + this.FORM_CLASS);
        this.side = this.order.find('.' + this.SIDE_CLASS);
        this.modal = $('#' + this.RESULT_MODAL_ID);
        this.basket = $('.' + this.BASKET_CLASS);
        this.emptyBasket = $('.' + this.EMPTY_ORDER_CLASS);
        this.aboutOrder = this.order.find('.' + this.ABOUT_ORDER_CLASS);

        this.setRequiredFields();

        this.basketItemChangeOffer = $('.' + this.BASKET_ITEM_CHANGE_OFFER_CLASS).bindToEntity(OfferSwitcher);
        this.basketItemQuantity = $('.' + this.BASKET_ITEM_QUANTITY_CLASS).bindToEntity(Quantity);
        this.promoCode = $('.' + this.PROMO_CODE_CLASS).bindToEntity(PromoCode);
        this.location = this.form.find('.' + this.LOCATION_INPUT_CLASS).bindToEntity(City);
        this.extraDiscount = $('.' + this.EXTRA_DISCOUNT_MODAL_CLASS);

        this.bindEvents();
    }

    setElementClasses() {
        this.BASKET_CLASS = 'js-basket';
        this.BASKET_ITEM_ROW_CLASS = 'js-basket_item-row';
        this.ABOUT_ORDER_CLASS = 'js-order-about';

        this.FORM_CLASS = 'js-order_form';
        this.SIDE_CLASS = 'js-order_side';
        this.EMPTY_ORDER_CLASS = 'js-order-empty';

        this.ADDRESS_BLOCK_CLASS = 'js-order-address';

        this.LOCATION_INPUT_CLASS = 'js-location-input';

        this.DELIVERY_RADIO_CLASS = 'js-order_delivery';
        this.PAYMENT_RADIO_CLASS = 'js-order_payment';

        this.BASKET_ITEM_CHANGE_OFFER_CLASS = 'js-basket_item-change_offer';
        this.BASKET_ITEM_QUANTITY_CLASS = 'js-basket_item-quantity';
        this.PROMO_CODE_CLASS = 'js-order_promo-code';

        this.ERRORS_BLOCK_CLASS = 'js-order_errors';
        this.SUBMIT_BUTTON_CLASS = 'js-order_submit';

        this.GO_TO_ORDER_ABOUT_BUTTON_CLASS = 'js-go-to-order-about-wrapper';
        this.ORDER_ABOUT_WRAP_CLASS = 'js-order-about__wrap';

        this.RESULT_MODAL_ID = 'order-end';
        this.RESULT_MODAL_ORDER_ID_CLASS = 'js-order_id';
        this.RESULT_MODAL_ORDER_USER_NAME_CLASS = 'js-order_user_name';
        this.RESULT_MODAL_CLOSE_CLASS = 'js-order-redirect';

        this.EXTRA_DISCOUNT_MODAL_CLASS = 'js-extra-discount';
    }

    setRequiredFields() {
        this.requiredFields = this.form.find('.js-required:visible');
    }

    bindElementsSend() {
        this.bindElementSend($(window), 'mario.basket_item.remove', false, true);
        this.bindElementSend(this.promoCode, 'mario.bonuses.withdrawn');
        this.bindElementSend(this.promoCode, 'mario.bonuses.removed');
        this.bindElementSend(this.promoCode, 'mario.promo_code.set', false, true);
        this.bindElementSend(this.promoCode, 'mario.promo_code.removed', false, true);
        this.bindElementSend(this.basketItemQuantity, 'mario.basket_item.quantity.changed');
        this.bindElementSend(this.basketItemChangeOffer, 'mario.basket_item.offer.changed', false, true);
        this.bindElementSend(this.location, 'mario.city.changed', true);
        this.bindElementSend(this.form.find('.' + this.DELIVERY_RADIO_CLASS), 'change', true);
        this.bindElementSend(this.form.find('.' + this.PAYMENT_RADIO_CLASS), 'change', true);
        this.bindElementSend($(window), 'wizard.promocode', true, true);
    }
    bindElementsSave() {
        this.bindElementSave($('.' + this.SUBMIT_BUTTON_CLASS), 'click');
    }

    bindElementSend(element, eventName, bodyPreloader = false, withBasketReload = false) {
        element.off(eventName).on(eventName, (event) => this.send.call(this, event, bodyPreloader, withBasketReload));
    }
    bindElementSave(element, eventName) {
        element.off(eventName).on(eventName, (event) => this.save.call(this, event));
    }

    // Отправка данных формы (но не сохранение заказа)
    send(event, bodyPreloader = false, withBasketReload = false) {
        console.log('refresh')
        event.preventDefault();

        let body = $('body');

        if (bodyPreloader) {
            body.preloader('show');
        }

        let $this = this;

        if (
            event.namespace === 'basket_item.remove' &&
            $('.' + this.BASKET_CLASS).find('.' + this.BASKET_ITEM_ROW_CLASS).length < 1
        ) {
            $this.emptyBasket.show();
            $this.order.html('');

            setTimeout(() => {
                $('.slick-slider').slick('setPosition')
            }, 100);
        }

        $.post(this.form.attr('action'), this.form.serializeAll(), (html) => {
            try {
                html = JSON.parse(html);

                if (typeof html === 'object' && html.hasOwnProperty('type') && html.type === 'error') {
                    body.preloader('hide');

                    $this.showBasketChangesModal(html.value);

                    return;
                }
            } catch (exception) {}

            let form = $(html).find('.' + $this.FORM_CLASS),
                side = $(html).find('.' + $this.SIDE_CLASS),
                promoCode = $(html).find('.' + $this.PROMO_CODE_CLASS),
                basket = $(html).find('.' + $this.BASKET_CLASS),
                aboutOrder = $(html).find('.' + $this.ABOUT_ORDER_CLASS);

            let parser = new DOMParser(),
                document = parser.parseFromString(html, 'text/html'),
                extraDiscount = $(document.querySelector('.' + this.EXTRA_DISCOUNT_MODAL_CLASS));

            $this.form.html(form.html());
            $this.side.html(side.html());
            $this.promoCode.html(promoCode.html());
            $this.aboutOrder.find('.order-about-parent').html(aboutOrder.find('.order-about-parent').html());
            if ($this.extraDiscount.length) {
                $this.extraDiscount.replaceWith(extraDiscount);
            } else {
                extraDiscount.insertAfter($('main.main'));
            }
            extraDiscount.modal('show');

            $('.js-basket-mobile-title').html('корзина ' + aboutOrder.find('.js-basket-items-quantity').html());

            if (withBasketReload) {
                $this.basket.html(basket.html());

                if ($(html).find('.' + this.EMPTY_ORDER_CLASS).length > 0) {
                    $('.js-order').after($(html).find('.' + this.EMPTY_ORDER_CLASS).html());
                }
            }

            $this.bindEvents(withBasketReload);

            body.preloader('hide');
        });
    }
    save(event) {
        event.preventDefault();

        let $this = this,
            promise = new Promise((resolve, reject) => $this.promiseCheckRequiredFields.call($this, resolve, reject));

        promise.then(
            () => {
                return new Promise((resolve, reject) => $this.needAuthModal.call($this, resolve, reject));
            },
            () => {
                throw new Error('Required fields error');
            }
        ).then(
            () => {
                if (!this.form.find('#privacy_agree').is(':checked')) {
                    $this.replaceErrors(['Вы не дали своего согласия на обработку информации']);

                    return;
                } else {
                    $this.hideErrors();
                }

                $('body').preloader('show');

                //todo: skipAuthCheck
                $.post(this.form.attr('action') + '?action=saveOrderAjax&skipAuthCheck=1', this.form.serializeAll(), (result) => {
                    if (
                        result.hasOwnProperty('type') &&
                        result.type === 'error' &&
                        result.error_type !== 'auth'
                    )
                    {
                        $('body').preloader('hide');

                        switch (result.error_type) {
                            case 'auth':

                                $('.js-auth_modal').modal('show');
                                $('.js-auth_modal').find('input[name=USER_LOGIN]').val($this.form.find('#order_property_EMAIL').val());
//                                $this.showAuthModal = false;

                                break;

                            case 'changes':
                            default:
                                $this.showBasketChangesModal(result.value);
                                break;
                        }

                        return;
                    } else if (result.hasOwnProperty('order') && result.order.hasOwnProperty('ERROR')) {
                        $('body').preloader('hide');

                        let originalErrors = result.order.ERROR,
                            errors = [];

                        for (let type in originalErrors) {
                            if (!originalErrors.hasOwnProperty(type)) {
                                continue;
                            }

                            for (let i in originalErrors[type]) {
                                if (!originalErrors[type].hasOwnProperty(i)) {
                                    continue;
                                }

                                errors.push(originalErrors[type][i]);
                            }
                        }

                        let customModal = new CustomModal();
                        customModal.show('Ошибка во время создания заказа', errors.join('<br>'));

                        return;
                    }

                    let w = window.BX || top.BX, p = w.message('COOKIE_PREFIX');
                    w.setCookie((p ? p + '_' : '') + 'idle_discount', 1, {'expires': 63072000, 'path': '/'});

                    window.location.href = result.order.REDIRECT_URL;
                }, 'json');
            },
            () => {
                $('body').preloader('hide');
            }
        );
    }

    bindEvents(withBasketReload = false) {
        let
            promoCodeBlock = $('.' + this.PROMO_CODE_CLASS),
            promoCodeToggle = promoCodeBlock.find('.js-promo_code-toggle'),
            orderAboutWrap = $('.' + this.ORDER_ABOUT_WRAP_CLASS);

        this.form.find('.js-phone').bindToEntity(Phone);
        this.location = this.form.find('.js-city').bindToEntity(City);
        this.form.find('.' + this.ADDRESS_BLOCK_CLASS).bindToEntity(Address);
        this.promoCode = promoCodeBlock.bindToEntity(PromoCode);

        this.form.find('[data-entity="delivery-address"]').each((i, rootNode) => {
            const addressPicker = new AddressPicker({ rootNode, locationNode: this.location.get(0) });
            addressPicker.subscribe('toggleForm', () => this.setRequiredFields())
        });

        if (promoCodeBlock.hasClass('active')) {
            let
                newText = promoCodeToggle.data('text'),
                oldText = promoCodeToggle.text();

            promoCodeToggle = document.getElementsByClassName('js-promo_code-toggle')[0];

            $(promoCodeToggle).data('text', oldText);
            promoCodeToggle.text = newText;
        }

        $(promoCodeToggle).bindToEntity(Toggle);

        $('.selectpicker').selectpicker({size: 5});

        if (withBasketReload) {
            this.bindBasketEvents();
        }

        this.bindElementsSend();
        this.bindElementsSave();
        this.setRequiredFields();
        window.initSmallBasketBtn();
        // window.init_affix();

        const locationAuto = this.form.find('[data-entity="order-location-auto"]');
        locationAuto.on('click', () => {
            this.form.find(`.${this.LOCATION_INPUT_CLASS}`).val(locationAuto.data('locationCode'));
            this.location.trigger('mario.city.changed');
        });
        this.location.on('change', ({ target }) => {
            if (locationAuto.data('locationCode') === '') {
                return;
            }

            if ($(target).val() == '' || locationAuto.data('locationCode') != this.form.find(`.${this.LOCATION_INPUT_CLASS}`).val()) {
                locationAuto.show();
            }
        });

        $('.' + this.GO_TO_ORDER_ABOUT_BUTTON_CLASS).on('click', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: (orderAboutWrap.offset().top - 50)
            }, 500);
        });
    }
    bindBasketEvents() {
        this.basketItemChangeOffer = $('.' + this.BASKET_ITEM_CHANGE_OFFER_CLASS).bindToEntity(OfferSwitcher);
        this.basketItemQuantity = $('.' + this.BASKET_ITEM_QUANTITY_CLASS).bindToEntity(Quantity);

        $('.' + this.BASKET_CLASS).find('.js-toggle').bindToEntity(Toggle);

        rebindBasketItemButtons();
    }
    promiseCheckRequiredFields(resolve, reject) {
        if (!(checkRequiredFields(this.requiredFields) & this.checkPhoneValid() & this.checkEmailValid())) {
            let formBlock = $('.' + this.FORM_CLASS);
            $('html, body').animate({ scrollTop: (formBlock.offset().top - 20) }, 500, 'easeInSine');
            return reject();
        }

        return resolve();
    }
    checkEmailValid()
    {
        const $input = $('.' + this.FORM_CLASS + ' #order_property_EMAIL');
        $input.parent().removeClass('error');

        if ($input.val().length > 0) {
            if (is_email_valid($input.val())) {
                return true;
            } else {
                $input.parent().addClass('error');
                return false;
            }
        }

        return true;
    }
    checkPhoneValid() {
        let $phone = $('.' + this.FORM_CLASS + ' #order_property_PHONE'), val;

        $phone.parent().removeClass('error');

        val = $phone.val().replace(/\D/g, '');
        if ($.isNumeric(val) && val.length === 11) {
            return true;
        } else {
            $phone.parent().addClass('error');
            return false;
        }
    }
    needAuthModal(resolve, reject) {
        let
            $this = this,
            $email = $('.' + $this.FORM_CLASS + ' #order_property_EMAIL'),
            $phone = $('.' + $this.FORM_CLASS + ' #order_property_PHONE');

        $.post('/ajax/user/find/', {phone: $phone.val(), email: $email.val()}, function(result) {
            if (result.need_auth) {
                let
                    $auth_by_phone_modal = $('.js-auth_order_modal_by_phone'),
                    $auth_by_email_modal = $('.js-auth_order_modal'),
                    $forgot_password_modal = $('.js-forgot_password_modal');

                $('.js-phone', $auth_by_phone_modal).val($phone.val());
                $('.js-sms_verification-phone', $auth_by_phone_modal).trigger('change');

                $('input[name="USER_LOGIN"]', $auth_by_email_modal).val($email.val());
                $('input[name="USER_PASSWORD"]', $auth_by_email_modal).val('');

                $('input[name="USER_LOGIN"]', $forgot_password_modal).val($email.val());

                if (result.by == 'phone') {
                    setTimeout(function() {
                        $auth_by_phone_modal.modal('show');
                        $('.js-sms_verification-phone-submit', $auth_by_phone_modal).trigger('click');
                    }, 50);
                } else {
                    $auth_by_email_modal.modal('show');
                }

                return reject();
            }

            return resolve();

        }, 'json');
    }
    hideErrors(clear = true) {
        let errorsBlock = $('.' + this.ERRORS_BLOCK_CLASS);

        errorsBlock.slideUp(200, () => {
            if (clear) {
                errorsBlock.find('ul').html('');
            }
        });
    }
    showErrors(errors) {
        let errorsBlock = $('.' + this.ERRORS_BLOCK_CLASS),
            errorsBlockList = errorsBlock.find('ul');

        for (let key = 0; key < errors.length; key++) {
            errorsBlockList.append('<li>' + errors[key] + '</li>');
        }

        errorsBlock.slideDown(200);
        errorsBlockList.slideDown(200);
    }
    replaceErrors(errors) {
        let $this = this,
            errorsBlock = $('.' + this.ERRORS_BLOCK_CLASS),
            errorsBlockList = errorsBlock.find('ul');

        if (errorsBlock.is(':visible')) {
            errorsBlockList.slideUp(200, () => {
                errorsBlockList.html('');

                $this.showErrors(errors);
            });
        } else {
            $this.showErrors(errors);
        }
    }
    showBasketChangesModal(html) {
        const modal = BX.Tag.render`${html}`;

        if (document.querySelector('#basket_changes')) {
            BX.Dom.replace(
                document.querySelector('#basket_changes'), 
                modal
            );
        } else {
            BX.Dom.append(
                modal, 
                document.body
            );
        }
        
        new BasketChanges({ rootNode: modal });
        modal.on('hide.bs.modal', () => window.location.reload());
    }

    static checkoutFast(form, errorModal, fastBuyModal, successModal) {
        $('body').preloader('show');

        $.post(form.attr('action'), form.serialize(), (result) => {

            if (!result.hasOwnProperty('type')) {
                console.error(result);

                return;
            } else if (result.type === 'error') {
                errorModal.show('Во время создания заказа произошла ошибка', result.value);
                fastBuyModal.find('.modal-body').preloader('hide');

                $('.js-auth_show').click(function(event){
                    event.preventDefault();
                    errorModal.close();
                    $('.js-auth_main_modal').modal('show');
                    $('.js-sms_verification-phone').focus();
                });

                return;
            }

            if (result.redirect) {
                window.location = result.redirect;
                return;
            }

            fastBuyModal.off('hide.bs.modal');

            form.closest('.modal').modal('hide');

            fastBuyModal.on('hide.bs.modal', () => {
                setTimeout(() => fastBuyModal.off('hide.bs.modal'), 100);

                return false;
            });

            try {
                let dataLayerTransactionData = window.dataLayerTransactionData || [];
                let dataLayer = window.dataLayer || [], advcake_data = window.advcake_data || [];

                dataLayerTransactionData['transactionid'] = $(".js-fast-order_id").val();
                dataLayer.push({'event':'crto_transactionpage','crto':dataLayerTransactionData});
                
                dataLayer.push({
                    'page_type': 'transaction',
                    'event': 'transaction',
                    'total_value': result.total_value,
                    'fb_value': result.total_value,
                    'product_ids': result.product_ids
                });

                if (result.flocktory) {
                    dataLayer.push(Object.assign({ event: "fl_postcheckout" }, result.flocktory));
                }
                

                advcake_data.push(result.advcake);
            } catch (exception) {}

            successModal.find('.js-order_id').text(result.value);
            successModal.modal('show');

            $(document.body).append('<script>' + result.actionpay + '</script>');
        }, 'json');
    }
}
